<template>
  <div class="silver_border_bottom pb-2 product_name_comp">
    <p class="mb-1 mt-1">
      <small class="text-pencil">{{ clientName }}</small>
    </p>
    <h2 class="mb-0 mt-0">{{ productName }}</h2>
    <p> <span v-html="DisplayPrice"/><br/><span v-html="DisplayDiscount"/></p>
    <div class="product_highlights mb-0">
      <span v-if="difficulty" class>
        <i class="check_icon" />
        <!-- <small>Difficulty</small> -->
        <span>{{ difficulty }}</span>
      </span>
      <span v-if="duration">
        <i class="check_icon" />
        <!-- <small>Duration</small> -->
        <span>{{ duration }}</span>
      </span>
      <span v-if="ageMinimum">
        <i class="check_icon" />
        <!-- <small>Ages</small> -->
        <span>{{ ageMinimum }}</span>
      </span>
      <span v-if="minHeight" class>
        <i class="check_icon" />
        <!-- <small>Min Height</small> -->
        <span>{{ minHeight }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "productName",
    "clientName",
    "duration",
    "ageMinimum",
    "difficulty",
    "minHeight",
    "DisplayPrice",
    "DisplayDiscount",
    "privateToursOnly",
    "OverrideAutoPrice",
    "Savings"
  ],

  name: "ProductName"
};
</script>

<style></style>
